import SSHeadline from "@core-components/title/SSHeadline";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Trans } from "react-i18next";
import Emoji from "../../shared/emoji/Emoji";
import InfoArea from "../../shared/info-area/InfoArea";

export const SmurfsRankedInfo = () => {
  const { t } = useAppTranslation("pages.ranked");

  return (
    <InfoArea
      hasShadow
      className="xs:!p-10 my-20"
      description={
        <div className="text-[16px]">
          <Trans i18nKey="pages.ranked.infoArea.description">
            Un compte classé dans League of Legends est un compte ayant
            participé au mode compétitif (Ranked), avec un classement dans une
            ligue (de Fer à Challenger). Il reflète les performances du joueur
            et son niveau dans la hiérarchie du jeu.
            <br />
            <br />
            <strong>Avantages</strong> : Avec les comptes déjà classés, on gagne
            énormément de temps.
            <br />
            <br />
            Nos comptes ont tous été vérifiés par notre équipe avant d’être mis
            en vente.
          </Trans>
        </div>
      }
      fullWidth={false}
      headLine={
        <SSHeadline props={{ title: { ff: "unset" } }}>
          <Emoji.Pin />
          <SSWhiteText> {t("infoArea.headline")}</SSWhiteText>
        </SSHeadline>
      }
    />
  );
};
